import { widgetTranslations } from '@/resources/widget-translations';
import { findResAst, getImageObject, getRefName } from '../utils';
import { widgetNameMap } from '../widget-name-map';

export function JsFileHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    jsPreview: getImageObject(resAst, getRefName(layerAst.attrsMap.bg), colors)
  };
  layer.type = 'JsFile';
  const jsFile = findResAst(resAst, getRefName(layerAst.attrsMap.args))[0];
  layer.attrs.jsFilename = jsFile.attrsMap.fileName;
  resAst.children.forEach((item) => {
    if (
      item.tag == 'File' &&
      item.attrsMap._comId == layerAst.attrsMap.name &&
      item != jsFile
    ) {
      const fileName = item.attrsMap.fileName.replace('\\', '/');
      layer.attrs.jsImgNames = [...(layer.attrs.jsImgNames ?? []), fileName];
    }
  });
}

export function WidgetLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  const {
    jumpApp,
    flex_direction = 'disabled',
    justify_content,
    align_content = 'flex-start',
    align_items = 'flex-start',
    gap = '0',
    _space,
    groupType,
    w,
    h,
    widgetName
  } = layerAst.attrsMap ?? {};
  // 处理js程序
  if (jumpApp == 'jsApplication' || groupType == 'jsApplication') {
    JsFileHandler(resAst, layerAst, layer, colors);
    return;
  }
  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };

  layer.attrs.resources = {
    widgetPreview: getImageObject(
      resAst,
      getRefName(layerAst.attrsMap.preview),
      colors
    ),
    editBox: getImageObject(
      resAst,
      getRefName(layerAst.attrsMap.editBox),
      colors
    )
  };

  layer.attrs.jumpApp = jumpApp;
  // 添加高度和高度
  if (w) layer.attrs.w = Number(w);
  if (h) layer.attrs.h = Number(h);

  // 导入时恢复支付宝支付内容
  if (jumpApp === 'alipay' && layerAst.attrsMap.args) {
    const alipayImportMap: Record<string, string> = {
      paycode: 'paymentCode',
      tapPay: 'tapPay'
    };
    layer.attrs.jumpAppAlipayContent = alipayImportMap[layerAst.attrsMap.args] ?? 'openApp';
  }

  // 自动布局
  const isFlex =
    ['row', 'column'].includes(flex_direction) && !!justify_content;
  if (isFlex) {
    const _gap = Number(gap);
    const __space = Number(_space);
    const flexAttrs = ['flex-start', 'center', 'flex-end'];
    layer.attrs.flexDirection = flex_direction;
    layer.attrs.justifyContent = flexAttrs.includes(justify_content)
      ? justify_content
      : 'flex-start';
    layer.attrs.alignItems = flexAttrs.includes(align_content)
      ? align_content
      : flexAttrs.includes(align_items)
      ? align_items
      : 'flex-start';
    layer.attrs.gap = _space ? __space : Number.isNaN(_gap) ? 0 : _gap;
    layer.attrs.isFlex = true;
  }

  // 添加widgetName
  if (widgetName) {
    let key = widgetName;
    if (widgetNameMap[widgetName]) {
      key = widgetNameMap[widgetName];
    }
    if (Object.keys(widgetTranslations['zh_CN']).includes(key)) {
      layer.attrs.widgetName = key;
    }
  }
}
